<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header header-elements-inline">
          <h5 class="card-title">Employee Hours</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="offset-lg-2 col-lg-8 col-md-10 sol-sm-12">
              <div class="form-group">
                <label>Date:</label>
                <el-date-picker
                  v-model="searchDate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="to"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  format="MMM dd, yy"
                >
                </el-date-picker>
                <div v-if="searchDateError">
                  <span>{{ searchDateMessage }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="float-left">
                <el-tag
                  v-if="unapprovedTimeCardError"
                  type="warning"
                  effect="dark"
                  class="mb-2"
                >
                  {{ unapprovedTimeCardMessage }}
                </el-tag>
                <div
                  v-for="(duplicateTimeCard, index) in duplicateTimeCardErrors"
                  v-bind:key="`duplicateTimeCard_${index}`"
                >
                  <el-tag
                    v-if="duplicateTimeCard.error"
                    type="danger"
                    effect="dark"
                    class="mb-2"
                    style="height: auto;white-space: break-spaces;"
                  >
                    {{ duplicateTimeCard.message }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="offset-lg-2 col-lg-2 col-md-10 sol-sm-12">
              <div class="text-right">
                <button
                  class="btn btn-primary mr-3"
                  v-on:click="printPDF()"
                  :disabled="isPrintDisabled"
                >
                  <div>Print <i class="icon-file-pdf ml-2"></i></div>
                </button>

                <button
                  :disabled="isSearchDisabled"
                  type="button"
                  class="btn btn-primary"
                  v-on:click="searchCards"
                >
                  <span>
                    Search
                  </span>
                  <i v-if="!isLoading" class="icon-search4 ml-2"></i>
                  <spring-spinner
                    :animation-duration="3000"
                    :size="15"
                    color="white"
                    v-else
                    style="display: inherit; vertical-align: inherit;"
                    class="ml-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- all employees table -->
    <allEmployeesPayrollv2
      v-if="searchValid && isReportVisible"
      id="allEmployeesTable"
      :hideEmployeesWithNoHours="true"
      :users="users"
      :searchDate="searchDate"
      :fromHoursWorked="true"
      @updateFromAllEmployees="updateFromAllEmployees"
    ></allEmployeesPayrollv2>
    <!-- /all employees table -->
  </div>
</template>

<script>
import allEmployeesPayrollv2 from '../childComponents/allEmployeesPayrollv2.vue';
import { SpringSpinner } from 'epic-spinners';
import { db } from '../../assets/js/firebase/db.js';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { generateDocDefinition } from '../childComponents/hoursWorkedReportPDF';

export default {
  name: 'employeeHours',
  components: {
    allEmployeesPayrollv2,
    SpringSpinner
  },
  data() {
    return {
      users: [],
      searchDate: null,
      searchDateError: false,
      searchDateMessage: null,
      isSearchDisabled: false,
      isLoading: false,
      searchValid: false,
      isReportVisible: false,
      unapprovedTimeCardMessage: null,
      unapprovedTimeCardError: false,
      duplicateTimeCardErrors: [],
      totals: null,
      hoursWorkedJobSpecificTotals: null,
      columnsToShow: null,
      employeesToShow: null,
      isPrintDisabled: true
    };
  },
  methods: {
    searchCards: async function() {
      if (this.validateSearch() === true) {
        this.searchValid = true;
        this.isSearchDisabled = true;
        this.isLoading = true;
        this.isReportVisible = true;
      }
    },
    validateSearch: function() {
      let flag = true;
      if (this.searchDate == null) {
        this.searchDateError = true;
        this.searchDateMessage = 'The date selection cannot be empty.';
        flag = false;
      } else {
        this.searchDateError = false;
        this.searchDateMessage = null;
        flag = true;
      }
      return flag;
    },
    updateFromAllEmployees: function(
      totals,
      data,
      allData,
      error,
      message,
      duplicateErrors,
      allEmployeeJobSpecificTotals,
      hoursWorkedJobSpecificTotals,
      columnsToShow,
      employeesToShow
    ) {
      //if there are ongoing timecards in the date selection, we get the messages here and set the flag.
      this.unapprovedTimeCardError = error;
      this.unapprovedTimeCardMessage = message;
      this.duplicateTimeCardErrors = duplicateErrors;

      this.totals = totals;
      this.hoursWorkedJobSpecificTotals = hoursWorkedJobSpecificTotals;
      this.columnsToShow = columnsToShow;
      this.employeesToShow = employeesToShow;

      //turn the loader off once we get data back from the server.
      if (data.length > 0) {
        this.isLoading = false;
        this.isPrintDisabled = false;
      }
    },
    getUsers: function() {
      //get the user list.
      db.collection('users')
        .where('company', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (this.$store.state.showInactiveEmployees === 'Yes') {
              this.users.push({
                id: doc.id,
                name: doc.data().name,
                type: doc.data().type,
                averagingAgreement: doc.data().averagingAgreement ? true : false
              });
            } else if (!doc.data().deactiveDate) {
              this.users.push({
                id: doc.id,
                name: doc.data().name,
                type: doc.data().type,
                averagingAgreement: doc.data().averagingAgreement ? true : false
              });
            }
          });
        })
        .catch(err => {
          console.log(`Error getting users: ${err}`);
        });
    },
    printPDF() {
      let docDefinition = generateDocDefinition(
        this.hoursWorkedJobSpecificTotals,
        this.columnsToShow,
        this.employeesToShow,
        this.jobs,
        moment(this.searchDate[0]).format('MMM DD, YY'),
        moment(this.searchDate[1]).format('MMM DD, YY')
      );
      pdfMake.createPdf(docDefinition).download();
    }
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    jobs() {
      return this.$store.state.jobs;
    }
  },
  watch: {
    searchDate() {
      this.isReportVisible = false;
      this.isSearchDisabled = false;
      this.isPrintDisabled = true;
    }
  }
};
</script>
s
